<template>
  <div>
    <search-form @search="onSearch"></search-form>

    <el-pagination
      @size-change="search"
      @current-change="search"
      :current-page.sync="query.pageIndex"
      :page-sizes="[10, 20, 30, 40]"
      :page-size.sync="query.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="total"
    ></el-pagination>

    <el-table :data="tableData" v-loading="loading" border fit stripe>
      <el-table-column
        prop="sortNum"
        label="序号"
        width="60"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="workYear"
        label="年度"
        width="80"
      ></el-table-column>
      <el-table-column prop="boardName" label="评审机构"></el-table-column>
      <el-table-column prop="title" label="名称"></el-table-column>
      <el-table-column
        prop="levelName"
        label="抽取级别"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="typeName"
        label="抽取类型"
        width="170"
      ></el-table-column>
      <el-table-column
        prop="needCount"
        label="需专家数"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column label="新增时间/状态" width="160">
        <template slot-scope="scope">
          <div>
            {{ moment(scope.row.addTime).format('YYYY-MM-DD HH:mm:ss') }}
          </div>
          <el-tag
            size="medium"
            v-text="scope.row.stateName"
            v-bind:type="scope.row.allowEdit ? 'info' : 'success'"
          ></el-tag>
        </template>
      </el-table-column>
      <el-table-column label="抽取次数" width="85" align="center">
        <template slot-scope="scope">
          <el-tag>{{ scope.row.batchCount }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <div>
            <el-button @click="handleView(scope.row.gainEid)" type="text">
              查看详情
            </el-button>
            <el-button
              @click="handleExport(scope.row)"
              type="text"
              title="导出该抽取专家花名册"
            >
              导出Excel
            </el-button>
          </div>
          <div>
            <el-button
              v-if="scope.row.hasChange"
              @click="handleViewChange(scope.row.gainEid)"
              type="text"
            >
              变更申请
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="search"
      @current-change="search"
      :current-page.sync="query.pageIndex"
      :page-sizes="[10, 20, 30, 40]"
      :page-size.sync="query.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="total"
    ></el-pagination>
  </div>
</template>
<script>
import SearchForm from '@/components/SearchGain/Admin.vue';
import { adminSearch } from '@/api/gains/opers/search.js';
import { exportMavin } from '@/api/gains/export.js';
import { exportExcel } from '@/utils/common';

export default {
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: 10
      },
      loading: false,
      tableData: [],
      total: 0
    };
  },
  components: {
    SearchForm
  },
  methods: {
    /** 搜索按钮操作 */
    onSearch(queryParams) {
      this.query.pageIndex = 1;
      Object.assign(this.query, queryParams);

      this.search();
    },
    handleView(gainEid) {
      window.open(`/gains/review/${gainEid}`, 'GavinView');
    },
    handleExport(row) {
      this.loading = true;
      exportMavin(row.gainEid).then(result => {
        exportExcel(result, `${row.boardName}-${row.title}`);
        this.loading = false;
      });
    },
    handleViewChange(gainEid) {
      window.open(`/gains/change/review/${gainEid}`, 'GavinChange');
    },
    search() {
      this.loading = true;
      adminSearch(this.query).then(res => {
        this.tableData = res.datas;
        this.total = res.totalRecords;
        this.loading = false;
      });
    }
  },
  created() {
    this.search();
  }
};
</script>
